import { usePostPortfolioLoansMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioLoansMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { LOANS_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/LoansForm/loansFormDefaults";
import { getLoansFormSchema } from "web_myplann/Portfolio/Forms/LoansForm/loansFormSchema";
import {
	LOAN_PRODUCT_CATEGORIES,
	type LoanType,
} from "web_myplann/Portfolio/Forms/LoansForm/loanType";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateLoansForm = (loanType: LoanType) => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioLoansMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getLoansFormSchema(t),
		defaultValues: LOANS_FORM_DEFAULT_VALUES,
		mutate: ({ change, ...portfolioFields }, options) =>
			mutate(
				{
					...portfolioFields,
					initialChange: change,
					productCategory: LOAN_PRODUCT_CATEGORIES[loanType],
				},
				options,
			),
		successRoute: Routing.Portfolio.PortfolioAddLoansSuccess.path(loanType),
	});

	return { form, onSubmit, isPending };
};
